// /about: what Ask HR is and isn't. Any signed-in employee. The wording is HR's, in
// content/about.ts; this is only the layout.

import { ABOUT_INTRO, ABOUT_LAST_REVIEWED, ABOUT_SECTIONS, ABOUT_TITLE } from "./content/about.js";
import { testing as testingDefault } from "./config.js";

// "2026-10-09" -> "October 9, 2026", as the date it is (not shifted by the viewer's time zone).
export const reviewedDate = (iso: string) =>
  new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-US", { dateStyle: "long", timeZone: "UTC" });

export function AboutPage({ testing = testingDefault }: { testing?: boolean }) {
  return (
    <section className="panel about" aria-labelledby="about-h">
      <h2 id="about-h">{ABOUT_TITLE}</h2>
      <p>{ABOUT_INTRO}</p>
      {ABOUT_SECTIONS.filter((s) => !s.testingOnly || testing).map((s) => (
        <p key={s.id} data-section={s.id}>
          <strong>{s.heading}:</strong> {s.text}
        </p>
      ))}
      <p className="sub">Last reviewed: {reviewedDate(ABOUT_LAST_REVIEWED)}</p>
    </section>
  );
}
